import React from 'react';
import { Wrapper } from './PacingTable.Styles';
import { DataGrid } from '@mui/x-data-grid';
var columns = [
    {
        field: 'name',
        headerName: 'Name',
        flex: 1
    },
    {
        field: 'value',
        headerName: 'Value',
        flex: 1
    },
];
export var PacingTable = function (_a) {
    var data = _a.data;
    var rows = [
        { id: '1', name: 'Clear Pacing', value: (data === null || data === void 0 ? void 0 : data.clearPacing) || '-' },
        {
            id: '2',
            name: 'Initial Calls per Agent',
            value: (data === null || data === void 0 ? void 0 : data.initialCpa) || '-',
            hide: (data === null || data === void 0 ? void 0 : data.clearPacing) === 'no'
        },
        {
            id: '3',
            name: 'Initial Calls per Agent Mode',
            value: (data === null || data === void 0 ? void 0 : data.initialCpaMode) || '-',
            hide: (data === null || data === void 0 ? void 0 : data.clearPacing) === 'no'
        },
        {
            id: '4',
            name: 'Initial Pacing Duration',
            value: (data === null || data === void 0 ? void 0 : data.initialDuration) || '-',
            hide: (data === null || data === void 0 ? void 0 : data.clearPacing) === 'no'
        },
        {
            id: '5',
            name: 'ABA Increment',
            value: (data === null || data === void 0 ? void 0 : data.abaIncrement) || '-',
            hide: (data === null || data === void 0 ? void 0 : data.clearPacing) === 'no'
        },
        {
            id: '6',
            name: 'CPA Modifier',
            value: (data === null || data === void 0 ? void 0 : data.cpaModifier) || '-',
            hide: (data === null || data === void 0 ? void 0 : data.clearPacing) === 'no'
        },
        {
            id: '7',
            name: 'ABA Calculation',
            value: (data === null || data === void 0 ? void 0 : data.abaCalculation) || '-',
            hide: (data === null || data === void 0 ? void 0 : data.clearPacing) === 'no'
        },
        {
            id: '8',
            name: 'ABA Target Rate %',
            value: (data === null || data === void 0 ? void 0 : data.abaTargetRate) || '-',
            hide: (data === null || data === void 0 ? void 0 : data.clearPacing) === 'no'
        },
    ];
    return (React.createElement(Wrapper, null,
        React.createElement(DataGrid, { rows: rows, columns: columns, pageSize: 10, rowsPerPageOptions: [10], hideFooter: true, autoHeight: true, density: 'compact' })));
};
PacingTable.defaultProps = {
// bla: 'test',
};
//# sourceMappingURL=PacingTable.js.map